import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import CustomButton, { CustomButtonProps } from "../Button";

interface ModalProps {
	title: string;
	style?: React.CSSProperties;
	children?: React.ReactNode;
	contentStyle?: React.CSSProperties;
	onClose: () => void;
	actions?: CustomButtonProps[];
}

const CustomModal: React.FC<ModalProps> = ({
	title,
	style,
	children,
	onClose,
	actions,
	contentStyle = {},
}) => {
	const modalStyle: React.CSSProperties = {
		width: "min(640px, calc(100vw - 24px))",
		maxHeight: "90dvh",
		...style,
	};

	const modalContentStyle: React.CSSProperties = {
		overflowY: "auto",
		maxHeight: "calc(90dvh - 80px)",
		...contentStyle,
	};

	return (
		<Dialog
			title={title}
			style={modalStyle}
			onClose={onClose}
			contentStyle={modalContentStyle}
		>
			<div>{children}</div>
			<DialogActionsBar>
				{actions?.map((action, index) => (
					<CustomButton {...action} key={index} />
				))}
			</DialogActionsBar>
		</Dialog>
	);
};

export default CustomModal;
